import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { SurveyModel } from '../../../../models/surveyModel';
import { loadMyUnansweredSurvey } from '../../../../core/store/survey/survey.actions';

@Component({
    selector: 'app-survey-list',
    templateUrl: './survey-list.component.html',
    styleUrls: ['./survey-list.component.scss'],
    standalone: false
})
export class SurveyListComponent extends BaseComponent implements OnInit {

  mySurveys: SurveyModel[];
  loadingMySurvey = false;
  
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private router: Router,
    private store: Store<State>) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.surveyState.mySurveys).subscribe(mySurveys => {
        this.mySurveys = mySurveys;
        if(mySurveys != null)
     	  	  	  this.totalRecords.set(mySurveys.length);
      }),
      this.store.select(s => s.surveyState.loadingMySurvey).subscribe(loadingMySurvey => {
        this.loadingMySurvey = loadingMySurvey;
      }),
    );

    this.store.dispatch(loadMyUnansweredSurvey());

  }

  viewSurvey(survey: SurveyModel) {
    this.router.navigate(['/survey/answer/' + survey.id]);
  }

}

